import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, ArrowUpRight, MessageSquare } from 'lucide-react';
import { companyInfo } from '../../data/company';

export const Footer: React.FC = () => {
  return (
    <footer className="bg-[#356aa5] dark:bg-[#050912] border-t border-sky-400/20 dark:border-slate-800/80 pt-16 pb-12 text-white dark:text-slate-400 text-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 pb-12 border-b border-white/20 dark:border-slate-800/80">
          {/* Brand Column */}
          <div className="lg:col-span-2 space-y-4">
            <Link to="/" className="flex items-center gap-3">
              <img
                src="/assets/technook/technook-logo-320.png"
                alt="TechNook Global Logo"
                className="h-10 w-auto object-contain brightness-0 invert"
              />
              <span className="text-xl font-black text-white tracking-tight">
                Tech<span className="text-sky-300">Nook</span> Global
              </span>
            </Link>
            <p className="text-white/90 dark:text-slate-300 text-xs leading-relaxed max-w-sm">
              {companyInfo.description}
            </p>
            <div className="pt-2 flex flex-col space-y-2 text-xs">
              <div className="flex items-center gap-2 text-white/90 dark:text-slate-300">
                <MapPin size={15} className="text-sky-300 shrink-0" />
                <span>Imperial Plaza, Diosdado Macapagal Blvd., Tambo, Parañaque City, Metro Manila</span>
              </div>
              <div className="flex items-center gap-2 text-white/90 dark:text-slate-300">
                <Mail size={15} className="text-sky-300 shrink-0" />
                <span>{companyInfo.email}</span>
              </div>
              <div className="flex items-center gap-2 text-white/90 dark:text-slate-300">
                <Phone size={15} className="text-sky-300 shrink-0" />
                <span>{companyInfo.phones.join(' | ')} (Viber & WhatsApp)</span>
              </div>
            </div>

            {/* Direct WhatsApp CTA Button */}
            <div className="pt-2">
              <a
                href="https://wa.me/639569284326"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-4 py-2 rounded-xl bg-white/15 hover:bg-white/25 text-white border border-white/30 text-xs font-semibold transition-all shadow-sm"
              >
                <MessageSquare size={14} className="text-emerald-300" />
                <span>Message on WhatsApp</span>
              </a>
            </div>
          </div>

          {/* Core Services Links */}
          <div className="space-y-3">
            <h4 className="text-xs font-bold uppercase tracking-wider text-white">Core Solutions</h4>
            <ul className="space-y-2 text-xs">
              <li><Link to="/services" className="text-white/90 hover:text-white transition-colors">Development Services</Link></li>
              <li><Link to="/services" className="text-white/90 hover:text-white transition-colors">Marketing & Brand Support</Link></li>
              <li><Link to="/services" className="text-white/90 hover:text-white transition-colors">Lead Gen & Sales Support</Link></li>
              <li><Link to="/services" className="text-white/90 hover:text-white transition-colors">Admin & Operations Support</Link></li>
            </ul>
          </div>

          {/* Quick Links */}
          <div className="space-y-3">
            <h4 className="text-xs font-bold uppercase tracking-wider text-white">Company</h4>
            <ul className="space-y-2 text-xs">
              <li><Link to="/about" className="text-white/90 hover:text-white transition-colors">About Technook</Link></li>
              <li><Link to="/about" className="text-white/90 hover:text-white transition-colors">Why Choose Us</Link></li>
              <li><Link to="/contact" className="text-white/90 hover:text-white transition-colors">Contact & RFP</Link></li>
              <li><Link to="/portfolio" className="text-white/90 hover:text-white transition-colors">Featured Portfolio</Link></li>
            </ul>
          </div>

          {/* Legal & Powered By Karma Technook */}
          <div className="space-y-4">
            <h4 className="text-xs font-bold uppercase tracking-wider text-white">Legal & Compliance</h4>
            <ul className="space-y-2 text-xs">
              <li><Link to="/privacy" className="text-white/90 hover:text-white transition-colors flex items-center gap-1">Privacy Policy <ArrowUpRight size={12} /></Link></li>
              <li><Link to="/terms" className="text-white/90 hover:text-white transition-colors flex items-center gap-1">Terms of Service <ArrowUpRight size={12} /></Link></li>
            </ul>

            {/* Official Powered By KARMA TECHNOOK Logo */}
            <div className="pt-2 border-t border-white/20 dark:border-slate-800">
              <span className="text-[10px] uppercase tracking-wider font-semibold text-white/80 block mb-1">
                Powered by
              </span>
              <img
                src="/assets/technook/karma-technook-white-640.png"
                alt="Powered by Karma TechNook"
                className="h-7 w-auto object-contain brightness-0 invert"
              />
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-white/80">
          <p>© {new Date().getFullYear()} TechNook. All rights reserved.</p>
          <p>official.technookglobal.com • Parañaque City, Metro Manila</p>
        </div>
      </div>
    </footer>
  );
};
